const Product = () => {
  const productBar = document.querySelector(".product-bar");

  if (productBar) {
    const triggerAdd = document.querySelector(".product-form__submit");
    function throttle(func, timeFrame) {
      var lastTime = 0;
      return function () {
        var now = new Date();
        if (now - lastTime >= timeFrame) {
          func();
          lastTime = now;
        }
      };
    }

    document.addEventListener(
      "scroll",
      throttle(() => {
        let triggerY = window.innerHeight;

        if (triggerAdd) {
          triggerY = triggerAdd.offsetTop;
        }

        if (window.scrollY > triggerY) {
          productBar.classList.remove("off-screen");
          document.body.classList.add("has--product-bar");
        } else {
          productBar.classList.add("off-screen");
          document.body.classList.remove("has--product-bar");
        }
      }, 100)
    );
  }

  // subscribe widget. If has_selling_plan changes value then update the `active` class on the parent element
  const sellingPlan = document.querySelectorAll(
    'input[name="has_selling_plan"]'
  );

  if (sellingPlan.length > 0) {
    sellingPlan.forEach((el) => {
      el.addEventListener("change", function (e) {
        const parent = el.closest(".product-form__selling-plans-toggle");

        if (parent) {
          if (el.checked) {
            parent.classList.add("active");

            // remove the active class from any other parent elements
            const others = document.querySelectorAll(
              ".product-form__selling-plans-toggle.active"
            );

            others.forEach((other) => {
              if (other !== parent) {
                other.classList.remove("active");
              }
            });
          } else {
            parent.classList.remove("active");
          }
        }
      });
    });
  }

  const targetNode = document.getElementById("shopify-product-reviews-holder");

  function containsWhoUsedAgeTag(element) {
    return /\[who_used_age:\s*\d+\]/.test(element.innerHTML);
  }

  function removeAgeTagReadMore(reviews) {
    reviews.forEach((review) => {
      const toggleContentBtn = review.querySelector(".yotpo-read-more");

      if (!toggleContentBtn) {
        return;
      } else {
        toggleContentBtn.addEventListener("click", () => {
          const reviewContent = review.querySelector(".yotpo-read-more-text");

          if (containsWhoUsedAgeTag(reviewContent)) {
            reviewContent.innerHTML = reviewContent.innerHTML.replace(
              /\[who_used_age:\s*\d+\]/g,
              ""
            ); // Remove the "[who_used_age: xx" from the content
          }
        });
      }
    });
  }

  function removeAgeTag(reviews) {
    reviews.forEach((review) => {
      const reviewContent = review.querySelector(".yotpo-read-more-text");

      if (reviewContent.classList.contains("age-removed")) {
        return;
      }
      reviewContent.innerHTML = reviewContent.innerHTML.replace(
        /\[who_used_age:\s*\d+\]/g,
        ""
      ); // Remove the "[who_used_age: xx" from the content
      reviewContent.innerHTML = reviewContent.innerHTML.replace(
        /\[who_used_age:/g,
        ""
      ); // Remove the "[who_used_age:" from the content
      reviewContent.classList.add("age-removed");
    });
  }

  const updateReviewUi = () => {
    targetNode?.classList.remove("loading");

    // remove all notice of [who_used_age: %d] from the review .yotpo-review-content div
    const reviews = document.querySelectorAll(".yotpo-review-content");

    removeAgeTag(reviews);
    removeAgeTagReadMore(reviews);
  };

  if (targetNode) {
    const config = { childList: true, subtree: true };

    // Callback function to execute when mutations are observed
    const callback = (mutationList, observer) => {
      for (const mutation of mutationList) {
        if (mutation.type === "childList") {
          updateReviewUi();
        }
      }
    };

    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
  }

  const filter = document.querySelector(".filter-by-matching-tag");

  // go through all li children and check to see if any of them match the tag
  // on the page. If so, include else hide away! Designed so we always see
  // `take` number of items but prioritise the ones that match the tag
  if (filter) {
    const matchTarget = filter.dataset.match;
    const take = filter.dataset.take;

    if (matchTarget) {
      var value = document.querySelector(matchTarget);

      if (value) {
        var tag = value.innerText.trim();

        // check for matching tag in any article__tags
        const items = filter.querySelectorAll("li");
        let found = 0;

        if (items.length > 0) {
          for (let i = 0; i < items.length; i++) {
            const item = items[i];

            if (found >= take) {
              item.remove();
              return;
            }

            let match = false;
            item.querySelectorAll(".article__tag").forEach((el) => {
              const tagValue = el.innerText.trim();
              if (tagValue === tag) {
                match = true;
              }
            });

            if (match) {
              found++;
              item.classList.remove("hidden");
            }
          }

          if (found < take) {
            // now show the rest up to take
            const items = filter.querySelectorAll("li.hidden");

            for (let i = 0; i < items.length; i++) {
              const item = items[i];

              if (found >= take) {
                item.remove();
              }
              // move the item to the last in the list
              item.classList.remove("hidden");

              found++;
            }
          }
        }
      } else {
        // no filter found just delete children after take amount
        const items = filter.querySelectorAll("li");

        if (items.length > take) {
          for (let i = take; i < items.length; i++) {
            const item = items[i];

            item.remove();
          }
        }
      }

      // if no ideas left then hide the whole section
      const items = filter.querySelectorAll("li:not(.hidden)");

      if (items.length === 0) {
        const sec = filter.closest("section");

        if (sec) {
          sec.remove();
        }
      }
    }
  }

  // replace
};

export default Product;
